
<template>
  <div class="detail_main bg_detail is-scrollable has-background-white">
    <div class="detail_img_info" v-if="detailReseauxPerso.faces.length">
      <div class="level is-mobile diapo_mount">
        <div class="level-left is-marginless">
          <a class="button has-text-white is-rounded diapo_button"
            @click="$parent.show = false">
            <span class="icon">
              <b-icon icon="chevron-left"></b-icon>
            </span>
            <label>Retour</label>
          </a>
        </div>
        <div class="level-right">
          <div class="button has-text-white is-rounded rightViolet diapo_count">
            <label>{{currentImg + 1}}/{{detailReseauxPerso.faces.length}}</label>
          </div>
        </div>
      </div>
      <img
        :src="url(img)"
        class="imageBgOpp imgGoToTop"
        v-touch:swipe.left="swipeLeft()"
        v-touch:swipe.right="swipeRight()">
    </div>
    <div class="leftVert topViolet rightVert bottomVert">
      <div class="tabs bottomVert">
        <ul class="p_size12 has-text-weight-bold">
          <li :class="{'underline is-active': active === 1}"
              @click="active = 1"
              class="is-paddingless">
            <a>Proposition</a>
          </li>
          <li :class="{'underline is-active': active === 2}"
              @click="active = 2"
              class="is-paddingless">
            <a>Caractéristiques</a>
          </li>
        </ul>
      </div>
      <div v-if="active === 1">
        <div class="column bottomViolet color-icon is-paddingless"
             v-if="detailReseauxPerso.dateDebut">
          <div class="media">
            <b-icon
              icon="timer"
              size="is-medium"
              class="media-left">
            </b-icon>
            <div class="media-content is-size-7">
              <label class="has-text-default">
                Période d'affichage
              </label><br>
              <p class="p_size12 has-text-weight-bold has-text-link">
                {{date(detailReseauxPerso.dateDebut) + ' au ' +
                  date(detailReseauxPerso.dateFin)}}
              </p>
            </div>
          </div>
        </div>
        <div class="columns is-mobile is-marginless is-multiline color-icon detail_content_propo">
          <div
            v-if="detailReseauxPerso.tarifHT"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="cash"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Tarif Brut HT
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{calTarif(detailReseauxPerso.tarifHT)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailReseauxPerso.tarifNet"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="cash"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Tarif Net HT
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{calTarif(detailReseauxPerso.tarifNet)}}
                </p>
                <span class="has-text-grey is-italic"
                  v-if="detailReseauxPerso.masquerRemiseEdition === true
                    && this.detailReseauxPerso.remise">
                  {{this.detailReseauxPerso.remise}} {{typeRemise}}
                </span>
              </div>
            </div>
          </div>
          <div
            v-if="detailReseauxPerso.tarifImpression"
            class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="printer"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-link is-size-7">
                <label class=" has-text-grey">
                  Tarif d'impression HT
                </label><br>
                <p class="p_size12 has-text-weight-bold">
                  {{calTarif(detailReseauxPerso.tarifImpression)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailReseauxPerso.taxeMunicipale"
            class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="ballot"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-link is-size-7">
                <label class=" has-text-grey">
                  Taxes municipales
                </label><br>
                <p class="p_size12 has-text-weight-bold">
                  {{calTarif(detailReseauxPerso.taxeMunicipale)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailReseauxPerso.tarifDePose"
            class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="sign-text"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-link is-size-7">
                <label class=" has-text-grey">
                  Tarif de pose HT
                </label><br>
                <p class="p_size12 has-text-weight-bold">
                  {{calTarif(detailReseauxPerso.tarifDePose)}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="detailReseauxPerso.commentaire">
          <p class="p_size12 has-text-weight-bold topViolet bottomViolet has-text-link">
            Commentaire:</p>
          <div class="commentaireMobile">
            <p class="has-text-link has-text-justify p_size11">
              {{detailReseauxPerso.commentaire}}
            </p>
          </div>
        </div>
      </div>
      <div v-if="active === 2">
        <div class="columns is-mobile is-multiline color-icon">
          <div class="column" v-if="detailReseauxPerso.libelle">
            <p class="is-size-7 bottomViolet">
              <label class="has-text-default">
                Nom du réseau
              </label><br>
              <strong class="p_size12 has-text-link">
                {{detailReseauxPerso.libelle}}
              </strong>
            </p>
          </div>
          <div class="column">
            <div class="media">
              <b-icon
                icon="sign-text"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Nombre de faces
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailReseauxPerso.nbFaces}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!detailReseauxPerso.select" @click="contolSelect()"
      class="navbar is-fixed-bottom button is-primary boutonSelectM has-text-weight-bold">
      <p class="p_size11 centreM">Ajouter a ma sélection</p>
    </div>
    <div v-else @click="contolSelect()"
      class="navbar is-fixed-bottom button boutonRed boutonSelectM has-text-weight-bold">
      <p class="p_size11 centreM">Retirer de ma sélection</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { urlPhoto, formatNum, formatDateExplicite } from '@/services/opportunite/formatTab';

export default {
  name: 'detailReseauxPersonnaliseCompletDiapo',
  props: ['detailReseauxPerso'],
  data() {
    return {
      show: false,
      hoverButton: false,
      active: 1,
      currentImg: 0,
    };
  },
  computed: {
    img() {
      return this.detailReseauxPerso.faces[this.currentImg].urlPhoto;
    },
    getTarif() {
      let tarifNet = 0;
      let tarifDePose = 0;
      let taxeMunicipale = 0;
      let tarifImpression = 0;
      let tarifHT = 0;
      if (this.infoReseauxPersonnalise.tarifDePose) {
        tarifDePose = this.infoReseauxPersonnalise.tarifDePose;
      }
      if (this.infoReseauxPersonnalise.taxeMunicipale) {
        taxeMunicipale = this.infoReseauxPersonnalise.taxeMunicipale;
      }
      if (this.infoReseauxPersonnalise.tarifImpression) {
        tarifImpression = this.infoReseauxPersonnalise.tarifImpression;
      }
      if (this.infoReseauxPersonnalise.tarifHT) {
        tarifHT = this.infoReseauxPersonnalise.tarifHT;
      }
      if (this.infoReseauxPersonnalise.tarifNet) {
        tarifNet = this.infoReseauxPersonnalise.tarifNet;
        return tarifNet
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
      }
      return tarifHT
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
    },
    typeRemise() {
      if (this.detailReseauxPerso.typeDeRemise === 0) {
        return '% de remise inclus';
      }
      return '€ de remise inclus';
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.detailReseauxPerso.select = !this.detailReseauxPerso.select;
      if (this.detailReseauxPerso.select) {
        this.add(this.getTarif);
        this.addNbSelect();
      } else {
        this.substract(this.getTarif);
        this.substractNbSelect();
      }
    },
    calTarif(t) {
      return formatNum(t);
    },
    close() {
      this.$parent.show = false;
    },
    date(d) {
      return formatDateExplicite(d);
    },
    url(data) {
      return urlPhoto(data);
    },
    swipeLeft() {
      return () => {
        if (this.currentImg === this.detailReseauxPerso.faces.length - 1) {
          this.currentImg = 0;
        } else {
          this.currentImg += 1;
        }
      };
    },
    swipeRight() {
      return () => {
        if (this.currentImg === 0) {
          this.currentImg = this.detailReseauxPerso.faces.length - 1;
        } else {
          this.currentImg -= 1;
        }
      };
    },
  },

  mounted() {
    const test = document.querySelector('html');
    const test2 = document.querySelector('body');
    test.style.overflow = 'hidden';
    test2.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    const test2 = document.querySelector('body');
    test.style.overflow = '';
    test2.style.overflow = '';
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxPersonnalise/detailReseauxPersonnaliseCompletDiapo.vue